export default __webpack_public_path__ + "static/media/10353047.6d3cbb6d.png";